import service from '@/services/measurement-units/MeasurementUnitsService'

export const measurementUnitsModule = {
  namespaced: true,
  strict: process.env.NODE_ENV !== 'production',
  state: {
    measurementUnitsList: [],
    measurementUnit: {},
    loadingItems: false,
    pagination: {
      currentPage: 1,
      lastPage: 1,
      perPage: 10,
    },
  },
  mutations: {
    SET_MEASUREMENT_UNITS(state, payload) {
      if (payload.current_page) {
        state.currentPage = payload.current_page
        state.lastPage = payload.last_page
      }
      state.measurementUnitsList = payload.data ?? payload
    },
    SET_MEASUREMENT_UNIT(state, payload) {
      state.measurementUnit = payload
    },
    SET_LOADING_ITEMS(state) {
      state.loadingItems = !state.loadingItems
    },
  },
  actions: {
    async getAPI({ commit }, query = null) {
      try {
        commit('SET_LOADING_ITEMS')
        const response = await service.getMeasurementUnitsAPI(query)
        commit('SET_MEASUREMENT_UNITS', response)
        return response
      } finally {
        commit('SET_LOADING_ITEMS')
      }
    },
    async getMeasurementUnitAPI({ commit }, id) {
      let response = await service.getMeasurementUnitAPI(id)

      commit('SET_MEASUREMENT_UNIT', response)
    },

    async insertAPI({ dispatch, state }, payload) {
      const { status } = await service.insert(payload)
      dispatch('getAPI', {
        page: state.pagination.current_page,
      })
      return status
    },

    async deleteAPI({ dispatch, state }, payload) {
      const { status } = await service.delete(payload.CODIGO)
      dispatch('getAPI', {
        page: state.pagination.current_page,
      })
      return status
    },

    async updateAPI({ dispatch, state }, payload) {
      const { status } = await service.update(payload.data, payload.id)
      dispatch('getAPI', {
        page: state.pagination.current_page,
      })
      return status
    },
  },
  getters: {},
}
